import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './customerLogos.css';

const CustomerLogos = () => {
    const logos = [
        { src: '/assets/img/carousels/Corning.png', alt: 'Corning' },
        { src: '/assets/img/carousels/Freeman.png', alt: 'Freeman' },
        { src: '/assets/img/carousels/Uber.png', alt: 'Uber' },
        { src: '/assets/img/carousels/Sanity.png', alt: 'Sanity' },
        { src: '/assets/img/carousels/IBKR.png', alt: 'Interactive Brokers' },
        { src: '/assets/img/carousels/Applied.png', alt: 'Applied' },
        { src: '/assets/img/carousels/BetterUp.png', alt: 'BetterUp' },
        { src: '/assets/img/carousels/ForgeBio.png', alt: 'ForgeBio' },
        { src: '/assets/img/carousels/Notable.png', alt: 'Notable' },
        { src: '/assets/img/carousels/Extu.png', alt: 'Extu' },
        { src: '/assets/img/carousels/Exowatt.png', alt: 'Exowatt' },
    ];

    const settings = {
        dots: false,
        infinite: true,
        speed: 6000,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: "linear",
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    };

    return (
        <div className="section customer-logos-section">
            <div className="container">
                <h2 className="text-center mb-3">Powering Compensation for</h2>
                <div className="customer-logos-container">
                    <Slider {...settings}>
                        {logos.map((logo, index) => (
                            <div key={index} className="customer-logo-item">
                                <img
                                    src={logo.src}
                                    alt={logo.alt}
                                    className="customer-logo"
                                    loading="lazy"
                                    onError={(e) => {
                                        console.error(`Error loading image: ${logo.src}`);
                                        e.target.style.display = 'none';
                                    }}
                                />
                            </div>
                        ))}
                        {/* Duplicate logos for seamless loop */}
                        {logos.map((logo, index) => (
                            <div key={`duplicate-${index}`} className="customer-logo-item">
                                <img
                                    src={logo.src}
                                    alt={logo.alt}
                                    className="customer-logo"
                                    loading="lazy"
                                    onError={(e) => {
                                        console.error(`Error loading image: ${logo.src}`);
                                        e.target.style.display = 'none';
                                    }}
                                />
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </div>
    );
};

export default CustomerLogos; 